{
  "page": {
    "title": "Promotions"
  },
  "toolbar": {
    "create": "New promotion",
    "search_placeholder": "Search promotions or notes",
    "export": "Export",
    "all_sellers": "All sellers",
    "date_range_placeholder": "Select date range",
    "date_range_apply": "Apply",
    "date_range_clear": "Clear"
  },
  "create": {
    "title": "New promotion",
    "subtitle": "Create the promotion shell, then add gift rules in the builder.",
    "campaign_label": "Campaign",
    "campaign_placeholder": "Select a campaign",
    "name_label": "Promotion name",
    "name_placeholder": "e.g. Songkran GWP — Shopee",
    "marketplace_label": "Marketplace",
    "seller_label": "Seller ID",
    "seller_placeholder": "e.g. seller-1",
    "start_label": "Start",
    "end_label": "End",
    "rule_mode_label": "Rule mode",
    "cancel": "Cancel",
    "submit": "Create promotion",
    "err_campaign_required": "Campaign is required",
    "err_start_required": "Start is required",
    "err_end_required": "End is required",
    "err_at_least_one_channel": "Select at least one marketplace"
  },
  "column": {
    "activate": "Activate",
    "status": "Status",
    "name": "Promotion name",
    "seller": "Seller",
    "period": "Period",
    "progress": "Progress",
    "quota": "Quota",
    "created_by": "Created By",
    "note": "Note",
    "draft_group": "Draft · {{count}} channels"
  },
  "status": {
    "draft": "Draft",
    "active": "Active",
    "finish": "Finished",
    "archived": "Archived"
  },
  "filter": {
    "all_statuses": "All statuses",
    "all_marketplaces": "All marketplaces",
    "date_from": "From",
    "date_to": "To"
  },
  "activate": {
    "label": "Activate {{name}}",
    "activated": "Promotion activated",
    "finished": "Promotion finished",
    "deactivated": "Promotion moved to draft",
    "reopened": "Promotion reopened to draft",
    "locked": "Finished promotions cannot be reactivated"
  },
  "footer": {
    "showing": "Showing {{shown}} of {{total}} promotions"
  },
  "export_done": "Exported {{count}} promotion(s)",
  "bulk": {
    "selected": "{{count}} selected",
    "activate": "Activate",
    "finish": "Finish",
    "archive": "Archive",
    "clear": "Clear selection"
  },
  "action": {
    "activate": "Activate",
    "clone": "Clone",
    "reopen": "Reopen to draft",
    "reopen_hint": "Move back to draft to edit",
    "reopen_blocked_tooltip": "This promotion has redemptions — clone it to re-run instead.",
    "delete": "Delete",
    "edit": "Edit"
  },
  "detail": {
    "title": "Promotion builder",
    "back": "Back to promotions",
    "draft": "Draft",
    "field": {
      "campaign": "Campaign",
      "name": "Promotion name (required)",
      "marketplace": "Marketplace",
      "seller": "Seller",
      "note": "Note",
      "note_en": "Description (EN)",
      "note_th": "Description (ไทย)",
      "note_en_placeholder": "English description",
      "note_th_placeholder": "คำอธิบายภาษาไทย",
      "active_period": "Active period",
      "rule_mode": "Rule mode",
      "payment_method": "Payment method",
      "trigger_product": "Trigger Product",
      "trigger_skus": "Trigger SKUs",
      "min_spend": "Minimum spend",
      "gift_sku": "Gift SKU",
      "quantity": "Quantity",
      "total_gift_quota": "Total gift quota",
      "gift_cap_mode": "Gift cap mode"
    },
    "rule_mode": {
      "stack_all": "Stack all",
      "first_match": "First match wins"
    },
    "gift_cap": {
      "per_order": "One gift per order",
      "per_item": "One gift per qualifying item"
    },
    "payment": {
      "any": "Any",
      "cod": "Cash on delivery",
      "non_cod": "Non-COD"
    },
    "column": {
      "trigger": "Buy",
      "gift_addon": "Get",
      "constraints": "Condition"
    },
    "section": {
      "basics": "Basics",
      "targeting": "Targeting",
      "rule_mode": "Rule mode"
    },
    "rule_mode_note": "Stack all: every matching rule fires and the buyer claims all matching gifts. First match: evaluation stops at the first rule that passes.",
    "activate_note": "Activate from the Promotions list",
    "clone_saved_first": "Save the promotion before cloning to other marketplaces.",
    "cloned": "Promotion cloned to a new draft.",
    "empty_gifts": "No gifts added yet",
    "add_rule": "Add another rule"
  },
  "rule": {
    "title": "Rule {{n}}",
    "move_up": "Move up",
    "move_down": "Move down",
    "expand": "Expand rule",
    "collapse": "Collapse rule",
    "add_sku": "Add SKUs",
    "add_gift": "Add gift",
    "exclude_min_spend": "Exclude from min-spend"
  },
  "builder": {
    "save": "Save",
    "save_draft": "Save draft",
    "saved": "Promotion saved",
    "linked_group_banner": "Draft · editing {{count}} channels",
    "activate_for_n_channels": "Activate for {{count}} channels",
    "trigger_type": {
      "label": "Applies to",
      "all": "All SKU",
      "specific": "Specific SKUs"
    },
    "trigger_sku_count": "SKU ({{count}})",
    "pick_by_product": "Select trigger products",
    "pick_by_sku": "Add trigger SKUs",
    "gift_expands_to": "Reserves base stock",
    "add_on": {
      "single_sku_hint": "Single SKU gift — reserved directly, no bundle expansion"
    },
    "is_min_spend": "Require minimum spend",
    "min_spend_value": "Minimum spend (THB)",
    "discount": {
      "label": "Discount",
      "include": "Include in qualifying spend",
      "exclude": "Subtract from qualifying spend",
      "include_short": "Include",
      "exclude_short": "Exclude"
    },
    "shipping_fee": {
      "label": "Shipping",
      "include": "Include in qualifying spend",
      "exclude": "Exclude from qualifying spend",
      "include_short": "Include",
      "exclude_short": "Exclude"
    },
    "gift_limit_type": {
      "label": "Gift limit type",
      "per_order_short": "Per order",
      "per_item_short": "Per item"
    },
    "gift_limit_quantity": "Gift quota",
    "gift_used_offset": "Already used before Atlas",
    "gift_used_offset_hint": "Counted as used. Set at cutover from the previous system.",
    "gift_used_offset_toggle": "Migrating from a legacy system?",
    "quota_used": "Used",
    "quota_remaining": "Remaining",
    "quota_pct_used": "{{pct}}% used",
    "quota_no_limit": "No limit",
    "add_sku_short": "Add",
    "sku_paste": {
      "label": "Paste SKU codes",
      "resolve": "Resolve",
      "result": "Found {{found}}, {{unrecognized}} unrecognized"
    },
    "err_name_required": "Promotion name is required",
    "err_seller_required": "Seller is required",
    "err_dates": "End must be after start",
    "err_no_rules": "Add at least one rule",
    "err_no_trigger_or_min_spend": "Add a trigger SKU, or set a minimum spend for a storewide rule",
    "err_no_gift": "Add at least one gift SKU",
    "err_min_spend_required": "Enter a minimum spend greater than 0",
    "err_trigger_n_required": "Enter how many triggers must match",
    "err_sku_required": "SKU is required",
    "err_money_format": "Amount must be a valid number with up to 2 decimal places",
    "err_money_negative": "Amount cannot be negative",
    "err_gift_used_offset_negative": "Already-used offset cannot be negative",
    "err_cannot_save": "Can't save yet",
    "err_fix_required": "Fix the highlighted fields before saving"
  },
  "picker": {
    "title": "Select SKUs",
    "subtitle_single": "Search or paste, then choose one gift SKU.",
    "subtitle_multi": "Search or paste codes, then check the SKUs to add.",
    "add": "Add {{count}}",
    "cancel": "Cancel",
    "tab_search": "Search",
    "tab_paste": "Paste",
    "search_label": "Search SKUs",
    "search_placeholder": "Search by product name…",
    "search_empty": "Type to search the SKU catalogue.",
    "search_loading": "Searching…",
    "search_no_results": "No SKUs match your search.",
    "selected_count": "{{count}} selected"
  },
  "precheck": {
    "title": "Activation pre-check",
    "passed": "Ready to activate",
    "blocked": "Resolve these before activating:",
    "activate": "Activate",
    "checking": "Checking…",
    "activated": "Promotion activated",
    "rule_prefix": "Rule {{n}}",
    "toast_blocked": "{{name}} can't be activated:",
    "reason": {
      "no_rules": "Add at least one rule",
      "missing_add_on": "Add at least one gift SKU",
      "invalid_dates": "End date must be after start date",
      "quota_zero": "Gift limit quantity must be at least 1",
      "missing_trigger_or_min_spend": "A storewide rule (no trigger SKU) needs a minimum spend"
    }
  },
  "simulate": {
    "title": "Simulate cart",
    "add_line": "Add line",
    "sku": "SKU",
    "quantity": "Qty",
    "unit_price": "Unit price (THB)",
    "discount": "Discount (THB)",
    "shipping": "Shipping (THB)",
    "total_paid": "Total paid",
    "is_cod": "Cash on delivery",
    "run": "Run simulation",
    "empty_title": "Preview this promotion",
    "empty": "Enter a sample cart above, then Run to see which rules fire and what gifts are awarded.",
    "fired_rules": "Rules that fired",
    "no_fire": "No rules fired for this cart",
    "min_spend_math": "Minimum-spend check",
    "subtotal": "Subtotal",
    "threshold": "Threshold",
    "base": "Comparison base",
    "passed": "Passed",
    "failed": "Failed",
    "gifts_awarded": "Gifts awarded",
    "remove_line": "Remove line",
    "err_no_lines": "Add at least one cart line",
    "err_sku_required": "SKU is required",
    "err_money_format": "Amount must be a valid number with up to 2 decimal places",
    "err_money_negative": "Amount cannot be negative"
  },
  "report": {
    "title": "Promotion report",
    "subtitle": "Gift-with-purchase quota usage per SKU.",
    "search_placeholder": "Search SKU or name…",
    "all_platforms": "All platforms",
    "all_shops": "All shops",
    "all_time": "All time",
    "month_label": "Month",
    "column": {
      "sku": "SKU",
      "name": "SKU Name",
      "marketplace": "Platform",
      "shop": "Shop",
      "quota": "Quota",
      "used": "Used",
      "remaining": "Remaining"
    },
    "export_csv": "Export .xlsx",
    "export_done": "Exported {{count}} row(s)",
    "empty_title": "No rows match.",
    "empty_body": "Try adjusting the platform or shop filter."
  },
  "redemption": {
    "title": "Promotion Redemption",
    "subtitle": "Every gift awarded, newest first.",
    "redeemed": "Redeemed",
    "order_copied": "Order ID copied",
    "campaign_label": "Campaign",
    "promotion_label": "Promotion",
    "all_promotions": "All Promotions",
    "total_sets": "Total Redeemed Sets",
    "total_gift_qty": "Total Gift Qty",
    "search_placeholder": "Search promotions or notes…",
    "export": "Export",
    "clear": "Clear",
    "search": "Search",
    "export_done": "Exported {{count}} redemption(s)",
    "column": {
      "order_id": "Order ID",
      "promotion": "Promotion Name",
      "campaign": "Campaign Name",
      "seller": "Seller Name",
      "rule": "Rule",
      "gwp_sku": "GWP",
      "gwp_quantity": "Qty",
      "redeem_set": "Redeem Set",
      "payment_date": "Payment Date",
      "status": "Status",
      "total_amount": "Total (฿)"
    },
    "empty_title": "No redemptions found.",
    "empty_body": "Redemptions will appear here once orders are placed.",
    "all_campaigns": "All Campaigns"
  },
  "seller_select": {
    "placeholder": "Select a seller",
    "empty": "No shops connected on this marketplace yet",
    "stale": "{{id}} (not a connected shop)",
    "option": "{{name}} ({{id}})"
  },
  "seller": {
    "disconnected_note": "This shop is disconnected. Atlas is no longer fetching its orders. The rule is kept and will apply again when the shop is reconnected."
  },
  "empty": {
    "title": "No promotions yet",
    "body": "Create a promotion to start awarding gifts."
  },
  "performance": {
    "tabs_label": "Promotion views",
    "tab_setup": "Setup",
    "tab_performance": "Performance",
    "period_days": "{{n}} days",
    "period_day_of": "day {{day}} of {{total}}",
    "as_of": "Data as of {{time}}",
    "export": "Export CSV",
    "banner_running": "Still running · {{n}} days left · figures refresh on load, last {{time}}",
    "banner_in_transit": "Final · {{n}} orders still in transit, not yet delivered (included in GMV)",
    "kpi": {
      "orders": "Orders",
      "gmv": "GMV",
      "abv": "ABV",
      "uplift": "ABV uplift",
      "gifts": "Gifts given",
      "so_far": "so far",
      "orders_caption": "with gift",
      "gmv_caption": "non-gift lines",
      "abv_caption": "per order",
      "uplift_caption": "vs {{baseline}} no-gift · same period & marketplace",
      "uplift_insufficient": "needs ≥30 orders",
      "gifts_unused": "{{n}} unused",
      "gifts_on_pace": "on pace → ~{{n}}"
    },
    "col": {
      "brand": "Brand (AP)",
      "orders": "Orders",
      "units": "Units",
      "gmv": "GMV",
      "share": "Share",
      "abv": "ABV",
      "gift_sku": "Gift SKU",
      "name": "Name",
      "qty": "Qty",
      "sku": "SKU"
    },
    "brand": {
      "title": "Sales by brand",
      "unmapped": "Unmapped",
      "unmapped_skus": "{{n}} SKUs",
      "unmapped_tip": "{{n}} SKUs have no brand. Upload the brand CSV in Settings → SKU."
    },
    "gifts": { "title": "Gifts distributed" },
    "top": {
      "title": "Top SKUs sold",
      "show_all": "Show all {{n}}",
      "show_less": "Show top 10"
    },
    "total": "Total",
    "empty": "No redemptions yet",
    "empty_body": "Figures appear once an order receives this promotion's gift.",
    "error": "Couldn't load performance",
    "retry": "Retry",
    "report_link": "Performance reports →"
  }
}
